const settingsPage = {
  en: {
    settings: {
      title: 'Your account',
      subtitle: 'Overall',
      buttonEdit: 'Edit',
      buttonAdd: 'Add',
      fieldName: 'Name',
      fieldEmail: 'Email',
      fieldPhone: 'Phone number',
      fieldPassword: 'Password',
      buttonChangePassword: 'Change Password',
    },
    settingsEdit: {
      title: 'Your account',
      buttonCancel: 'Cancel',
      buttonSave: 'Save',
      notificationOnPasswordEdit: 'Password has been successfully edited',
      notificationOnEdit: 'has been successfully edited',
      name: {
        fieldName: 'First Name',
        fieldLastName: 'Last Name',
      },
      email: {
        subtitle: 'Current email',
        fieldNewEmail: 'New email',
      },
      password: {
        fieldOldPassword: 'Old Password',
      },
      phone: {
        fieldPhone: 'Phone Number',
      },
    },
  },
}
export default settingsPage
